import { Component, Input } from '@angular/core';
import { ErrorLogProperties, ErrorLogsService } from 'src/app/core/errorlogs.service';

@Component({
  selector: 'app-property-dialog',
  template: `
  <p-button (click)="showDialog()" icon="pi pi-external-link" label="Visualizza"></p-button>

  <p-dialog header="Properties" [(visible)]="display" [style]="{ width: '90vw' }">
    <table class="table table-bordered table-hover">
      <tbody>
        <tr *ngFor="let item of xmlItems">
          <td>{{item.chiave}}</td>
          <td>{{item.valore}}</td>
        </tr>
      </tbody>
    </table>
  </p-dialog>
  `,
  styles: [`
    table { font-family: arial, sans-serif; border-collapse: collapse; width: 100%; }
    td, th { border: 1px solid #dddddd; text-align: left; padding: 8px; white-space: pre-wrap; }
    tr:nth-child(even) { background-color: #eeeeee; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  `]
})
export class PropertyDialogComponent {
  @Input() public properties: string | undefined;
  public display = false;
  public xmlItems: ErrorLogProperties[] | undefined;

  constructor(private errorLogsService: ErrorLogsService) { }

  showDialog() {
    this.display = true;
    void this.errorLogsService.parseXML(this.properties)
      .then((data) => {
        this.xmlItems = data;
      });
  }
}
